import axios from "axios";

export default {
    data(){ return {
        results: [],
        awaiting: null,
        cancels: {
            default: undefined
        },
    }},
    methods: {
        payloadGET(params, cancelID){
            params = params ? params : this.params;
            cancelID = cancelID ? cancelID : "default";
            if(this.cancels[cancelID])
                this.cancels[cancelID].cancel(this.messages.cancel);
            const CancelToken = axios.CancelToken;
            this.cancels[cancelID] = CancelToken.source();
            var payload = {params: Object.assign({}, params)};
            payload.cancelToken = this.cancels[cancelID].token;
            return payload;
        },
        payloadPOST(params){
            params = params ? params : this.params;
            var payload = params;
            return payload;
        },
    },
}